import React from "react";
import { AmpHeader } from "components/amp";
import { logoUrl } from "lib/constants";

export default function PageAmpHeader(props: any) {
  const { iosUrl, androidUrl } = props;

  return (
    <AmpHeader iosUrl={iosUrl} androidUrl={androidUrl} logoUrl={logoUrl} />
  );
}
